"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlChargingSerialization = void 0;
const ChargerControlChargingPortStateSerialization_1 = require("./ChargerControlChargingPortStateSerialization");
const ChargerControlChargingPowerLimitCommandSerialization_1 = require("./ChargerControlChargingPowerLimitCommandSerialization");
class ChargerControlChargingSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.ports = entity.ports?.map((field) => field
            ? JSON.parse(ChargerControlChargingPortStateSerialization_1.ChargerControlChargingPortStateSerialization.serialize(field))
            : undefined);
        copy.active_power_limit_command = entity.active_power_limit_command
            ? JSON.parse(ChargerControlChargingPowerLimitCommandSerialization_1.ChargerControlChargingPowerLimitCommandSerialization.serialize(entity.active_power_limit_command))
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.ports = entity.ports?.map((field) => field
            ? ChargerControlChargingPortStateSerialization_1.ChargerControlChargingPortStateSerialization.deserialize(JSON.stringify(field))
            : undefined);
        copy.active_power_limit_command = entity.active_power_limit_command
            ? ChargerControlChargingPowerLimitCommandSerialization_1.ChargerControlChargingPowerLimitCommandSerialization.deserialize(JSON.stringify(entity.active_power_limit_command))
            : undefined;
        return copy;
    }
}
exports.ChargerControlChargingSerialization = ChargerControlChargingSerialization;
